// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const ConnectPaymentIntegrationPageSelector: MarkdocTagRegistration = {
  tag: 'connect-payment-integration-page-selector',
  component: 'ConnectPaymentIntegrationPageSelector',
};
